<template lang="pug">
    .conference(v-if="availableSeats > 0")
        input(type="radio" :id="labelId" :value="conference.id" name="conferences" @click="pickedConference({conference})")
        label(:for="labelId")
            .conference-row
                h4.event-title {{ conference.event_name }}

            .conference-row
                p {{ conference.start_date | formatDate }} - {{ conference.end_date | formatDate }}
                p {{ availableSeats }} participant{{ availableSeats | isPlural }} max

                p.organizer by {{ conference.host }}

            .conference-row
                a(href="" @click.prevent="clickedConference") More details

</template>

<script>
    import Vue from 'vue';
    import _ from 'lodash';
    import moment from 'moment';
    import conferencepoup from './ConferencePopup';

    export default {
        name: 'Conference',
        data() {
            return {
                labelId: null,
                conferenceId: null,
                maxCount: 0,
                availableSeats: 0
            }
        },
        components: {
            conferencepoup
        },
        props: ['conference'],
        methods: {
            clickedConference() {
                this.$emit('clickedConference', { 'id': this.conference.id, 'slug': this.conference.slug, 'availableSeats': this.availableSeats })
            },
            pickedConference(conference) {
                if(event.target.checked) {
                    this.$emit('pickedConference', { 'id': conference.conference.id, 'slug': conference.conference.slug });
                }
            },
            participantsCount() {
                var no_participants = 0;

                if(this.conference.confirmed_bookings) {

                    this.conference.confirmed_bookings.forEach(result => {
                        no_participants += parseInt(result.number_of_participants)
                    });

                    var seats = this.conference.no_of_public_participants_allowed - no_participants;

                    if(seats > 0) {
                        this.availableSeats = seats;
                        this.maxParticipants = this.availableSeats;
                    }
                }
            },
            ...Vue.filter('isPlural', function(value) {
                if(value) {
                    return (value > 1) ? 's' : '';
                }
            })                                    
        },
        mounted() {
            this.labelId = _.uniqueId();

            Vue.filter('formatDate', function(value) {
                if(value) {
                    return moment(String(value)).format('DD MMM YYYY')
                }
            });

            this.participantsCount()
        }
    };
</script>

<style lang="sass">
    @import "@/assets/css/2-base/_variables.sass"
    @import "@/assets/css/2-base/_placeholder.sass"
    @import "@/assets/css/3-components/_conference.sass"    
</style>


